import type { SiteConfig } from '../../../siteContentTypes.ts';
import { TextField, TextAreaField } from './fields.tsx';

export function FinalCtaSection({ config, update }: { config: SiteConfig; update: (patch: Partial<SiteConfig>) => void }) {
  const c = config.finalCta;
  const set = (patch: Partial<SiteConfig['finalCta']>) => update({ finalCta: { ...c, ...patch } });

  return (
    <div>
      <h2 style={{ fontSize: 18, fontWeight: 800, marginBottom: 20 }}>CTA final</h2>
      <TextField label="Titre" value={c.title} onChange={(v) => set({ title: v })} />
      <TextAreaField label="Sous-titre" value={c.subtitle} onChange={(v) => set({ subtitle: v })} rows={2} />
      <TextField label="Bouton 1 — texte" value={c.ctaPrimaryText} onChange={(v) => set({ ctaPrimaryText: v })} />
      <TextField label="Bouton 1 — lien" value={c.ctaPrimaryUrl} onChange={(v) => set({ ctaPrimaryUrl: v })} />
      <TextField label="Bouton 2 — texte" value={c.ctaSecondaryText} onChange={(v) => set({ ctaSecondaryText: v })} />
      <TextField label="Bouton 2 — lien" value={c.ctaSecondaryUrl} onChange={(v) => set({ ctaSecondaryUrl: v })} />
    </div>
  );
}
